import React from 'react';
import Select from 'react-select';
import {defaultSystemStates, systemCycleOptions} from "../../General/SystemLifeCycleStates";

export default function SystemCycleMultiSelect({systemCycleCallBack, setSelectedSystemStates, isRemote, isRequestInProgress}) {

    const handleSelectChange = (selectedOptions) => {
        setSelectedSystemStates(selectedOptions);
        if (!isRemote && systemCycleCallBack) {
            systemCycleCallBack(false, selectedOptions);
        }

    };

    return (
        <Select
            isDisabled={isRequestInProgress}
            defaultValue={defaultSystemStates}
            isMulti
            placeholder={'Select Water System States'}
            options={systemCycleOptions}
            onChange={handleSelectChange}
        />
    );
}
